import React, { useEffect, useState } from 'react';
import './UserManagementTab.css';
import { Button, Table, Select } from 'antd';
import CreateUser from './CreateUser/CreateUser';
import { useDispatch, useSelector } from 'react-redux';
import { MdEmail, MdOutlineDelete } from 'react-icons/md';
import { MdSave } from 'react-icons/md';
import { accessUser_ManagementList_RequestActionHandler } from '../../../../Redux/Actions/user/AccessUserManagementList';
import { userManagement_roles_list_ActionHandler } from '../../../../Redux/Actions/user/UserManagementRolesList';
import { workspace_roles_Permission_ActionHandler } from '../../../../Redux/Actions/user/WorkspaceRolePermissionList';
import { workspaces_List_ActionHandler } from '../../../../Redux/Actions/user/WorkspacesList';
import { AccessUserManagementUpdateActionHandler } from '../../../../Redux/Actions/user/AccessUserManagementUpdate';
import { SupportingDocumentUserDeleteHandler } from '../../../../Redux/Actions/user/SupportingDocumentsUserDelete';
import Swal from 'sweetalert2';
import { BASEURL } from '../../../../config';
import authAxios from '../../../../Config/AuthAxios';
const vuesaxlinearusercirlceadd = '/assets/vuesaxlinearusercirlceadd.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const { Option } = Select;
const UserManagementTab = () => {
    const dispatch = useDispatch();
    const [rollData, setRollData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [setroleid, setRoleId] = useState('');
    const [setuserid, setUserId] = useState('');
    const [workspaceroleChanges, setworkspaceRoleChanges] = useState(null);
    const [isAddCreditsOpen, setIsAddCreditsOpen] = useState(false);
    const [workspace, setWorkSpace] = useState([]);
    const [workspaceRoleData, setWorkSpaceRoleData] = useState([]);
    const [itemManagementState, setItemManagementState] = useState({});
    const [sortedRoles, setSortedRoles] = useState([]);
    const [sortedRolesUser, setSortedRolesUser] = useState([]);
    const userManagementRolesList = useSelector(
        (state) =>
            state?.userManagement_Roles_list_Data
                ?.userManagement_roles_list_data
    );
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspacesRolesList = useSelector(
        (state) =>
            state?.Workspace_Role_Permission_Roles_list_Data
                ?.workspace_roles_list_data
    );
    const userManagementList = useSelector(
        (state) => state?.AccsessUser_Management_Data?.user_management_list
    );

    const PermissionAccess = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data?.permissions
    );

    const [currentPage, setCurrentPage] = useState(1);
    const handleRoleChange = (userId, data, role_id) => {
        let accumulatedWorkspaceRoleChanges = { ...workspaceroleChanges };
        if (data === 'Account Owner - Enterprise') {
            let workspace_role_id = 4;
            setRoleId(role_id);
            setUserId(userId);
            workspaceRoleData?.map((workspacedata) => {
                accumulatedWorkspaceRoleChanges[
                    `${workspacedata.id}${userId}`
                ] = 'sadmin';
                setworkspaceRoleChanges(accumulatedWorkspaceRoleChanges);
                setItemManagementState((prevToggleState) => {
                    const updatedState = {
                        ...prevToggleState,
                        workspace_access: [
                            ...(prevToggleState.workspace_access || []),
                            {
                                workspace_id: workspacedata.id,
                                workspace_role_id: workspace_role_id,
                                userid: userId,
                            },
                        ],
                    };
                    return updatedState;
                });
            });
        } else {
            setUserId(userId);
            setRoleId(role_id);
        }
    };
    const handleWorkspaceRoleChange = (
        workspaceId,
        userId,
        workspace_role_id,
        data
    ) => {
        let accumulatedWorkspaceRoleChanges = { ...workspaceroleChanges };
        const workspaceRoleId = workspace_role_id;
        // if (data === "Workspace Owner - Enterprise") {
        //   setUserId(userId);
        //   workspaceRoleData?.map((workspacedata) => {
        //     accumulatedWorkspaceRoleChanges[`${workspacedata.id}${userId}`] =
        //       "sadmin";
        //     setworkspaceRoleChanges(accumulatedWorkspaceRoleChanges);
        //     setItemManagementState((prevToggleState) => {
        //       const updatedState = {
        //         ...prevToggleState,
        //         workspace_access: [
        //           ...(prevToggleState.workspace_access || []),
        //           {
        //             workspace_id: workspacedata.id,
        //             workspace_role_id: workspaceRoleId,
        //             userid: userId,
        //           },
        //         ],
        //       };
        //       return updatedState;
        //     });
        //   });
        // }  else {
        setUserId(userId);
        setworkspaceRoleChanges({
            ...workspaceroleChanges,
            [`${workspaceId}${userId}`]:
                data === 'Workspace Owner - Enterprise'
                    ? 'sadmin'
                    : data === 'Workspace Admin - Enterprise'
                    ? 'admin'
                    : data === 'Select Access'
                    ? ''
                    : 'user',
        });
        setItemManagementState((prevToggleState) => {
            let found = false;
            const updatedWorkspaceAccess = (
                prevToggleState.workspace_access || []
            ).map((access) => {
                if (
                    access.workspace_id === workspaceId &&
                    access.userid === userId
                ) {
                    found = true;
                    return {
                        ...access,
                        workspace_role_id: workspaceRoleId,
                    };
                }
                return access;
            });
            if (!found) {
                updatedWorkspaceAccess.push({
                    workspace_id: workspaceId,
                    workspace_role_id: workspaceRoleId,
                    userid: userId,
                });
            }
            const newState = {
                ...prevToggleState,
                workspace_access: updatedWorkspaceAccess,
            };
            return newState;
        });
        // }
    };

    const handleFinish = (userid) => {
        const filteredAccess = itemManagementState?.workspace_access?.filter(
            (item) => item.userid === userid
        );

        const newFilterAcess =
            filteredAccess?.map((item) => ({
                workspace_id: item.workspace_id,
                workspace_role_id: item.workspace_role_id,
            })) || [];

        const tempfilter = userManagementList?.data?.data?.filter(
            (item) => item.id === userid
        );
        const oldFilterAccess = tempfilter.map((item) => {
            return (
                item.workspace_access?.map((access) => ({
                    workspace_id: access.workspace_id,
                    workspace_role_id: access.workspace_role_id,
                })) || []
            );
        });

        const flattenedOldFilterAccess = oldFilterAccess.flat();

        const filteredOldFilterAccess = flattenedOldFilterAccess.filter(
            (oldAccess) => {
                return !newFilterAcess?.some(
                    (newAccess) =>
                        oldAccess.workspace_id === newAccess.workspace_id
                );
            }
        );

        const collectArr = [...filteredOldFilterAccess, ...newFilterAcess];
        let RoleId = tempfilter[0]?.role_id;
        if (setroleid) {
            RoleId = setroleid;
        }

        const updateCollectArr = collectArr.map((arr) => {
            if (arr.workspace_role_id === 'select') {
                arr.workspace_role_id = '';
            }
            return arr;
        });

        dispatch(
            AccessUserManagementUpdateActionHandler(
                userid,
                RoleId,
                updateCollectArr
            )
        );
        setTimeout(() => {
            setUserId('');
        }, 3000);
    };
    useEffect(() => {
        const sortRoles = (roles) => {
            const role4 = roles.find(
                (role) => role.name === 'Workspace Owner - Enterprise'
            );
            const role2 = roles.find((role) => role.name === 'Workspace Admin');
            if (role4 && role2) {
                const filteredRoles = roles.filter(
                    (role) =>
                        role.name !== 'Workspace Owner - Enterprise' &&
                        role.name !== 'Workspace Admin'
                );
                return [role4, role2, ...filteredRoles];
            }
            console.error('Roles with id 4 or 2 not found');
            return roles;
        };
        const sortRolesUser = (rolesUser) => {
            const role5 = rolesUser.find(
                (roleUser) => roleUser.name === 'Account Owner - Enterprise'
            );
            if (role5) {
                const filteredRolesUser = rolesUser.filter(
                    (roleUser) => roleUser.name !== 'Account Owner - Enterprise'
                );
                return [role5, ...filteredRolesUser];
            }
            console.error('Roles with id 4 or 2 not found');
            return rolesUser;
        };
        const sorted = sortRoles(workspace);
        const sortedRole = sortRolesUser(rollData);
        setSortedRoles(sorted);
        setSortedRolesUser(sortedRole);
    }, [workspace, rollData]);
    const columns = [
        {
            title: 'Name',
            dataIndex: 'first_name',
            key: 'name',
            width: 250,
            fixed: 'left',
            render: (text, record) => (
                <>
                    <p className='user-name'>
                        {record.first_name} {record.last_name}
                    </p>
                    <span className='user-email'>{record.email}</span>
                </>
            ),
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            width: 230,
            fixed: 'left',
            render: (text, record) => (
                <div>
                    <Select
                        className={`useraccess-role`}
                        onChange={(value, option) => {
                            const roleName = option?.children;
                            const role_id = value;
                            handleRoleChange(record.id, roleName, role_id);
                        }}
                        defaultValue={record.role_id}>
                        {sortedRolesUser?.map((role) => (
                            <Option key={role.id} value={role.id}>
                                {role.name}
                            </Option>
                        ))}
                    </Select>
                </div>
            ),
        },
        {
            title: 'Workspace Access',
            dataIndex: 'workSpaceAccess',
            key: 'workSpaceAccess',
            width: 150,
            render: (text, record) => (
                <div className='display-flex'>
                    {workspaceRoleData &&
                        workspaceRoleData?.map((workspacedata) => (
                            <>
                                <label
                                    key={workspacedata.id}
                                    className={`usermanagement-workSpaceAccess usermanagement-${
                                        workspaceroleChanges
                                            ? workspaceroleChanges[
                                                  `${workspacedata.id}${record.id}`
                                              ]
                                            : ''
                                    }`}>
                                    <label className='paddingRight-5px'>
                                        {workspacedata.name}
                                    </label>
                                    <Select
                                        className={`usermanagement-select usermanagement`}
                                        onChange={(value, option) => {
                                            const roleName = option?.children;
                                            handleWorkspaceRoleChange(
                                                workspacedata.id,
                                                record.id,
                                                value,
                                                roleName
                                            );
                                        }}
                                        value={
                                            itemManagementState
                                                ? (
                                                      itemManagementState.workspace_access ||
                                                      []
                                                  ).find(
                                                      (item) =>
                                                          item.workspace_id ===
                                                              workspacedata.id &&
                                                          item.userid ===
                                                              record.id
                                                  )?.workspace_role_id ||
                                                  record.workspace_access.find(
                                                      (temp) =>
                                                          workspacedata.id ===
                                                          temp.workspace_id
                                                  )?.workspace_role_id ||
                                                  'select'
                                                : 'select'
                                        }>
                                        <Option value='select'>
                                            Select Access
                                        </Option>
                                        {sortedRoles?.map((role) => (
                                            <Option
                                                key={role.name}
                                                value={role.id}>
                                                {role.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </label>
                            </>
                        ))}
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 100,
            render: (text, record) => (
                <div className='w-5'>
                    {record.id === setuserid ? (
                        <label
                            className='save-user-actions_active icon-mul'
                            onClick={() => handleFinish(record.id)}>
                            <MdSave />
                        </label>
                    ) : (
                        <label className='save-user-actions not-allowed icon-mul'>
                            <MdSave />
                        </label>
                    )}
                    {PermissionAccess &&
                        PermissionAccess?.some(
                            (permission) =>
                                permission?.slug === 'manage-all-users'
                        ) &&
                        record?.login_tracks_count == 0 && (
                            <MdEmail
                                title='Resend Invitation'
                                onClick={() => handleSendReInvite(record.id)}
                                className='icon-mul'
                            />
                        )}
                    {PermissionAccess &&
                    PermissionAccess?.some(
                        (permission) => permission?.slug === 'delete-users'
                    ) ? (
                        <MdOutlineDelete
                            className='icon-mul'
                            onClick={() => handleDeleteRole(record.id)}
                        />
                    ) : (
                        <MdOutlineDelete className='icon-mul permision-not-allowed-css' />
                    )}
                </div>
            ),
        },
    ];
    const AddCreditsOverlay = () => {
        setIsAddCreditsOpen(!isAddCreditsOpen);
        setTimeout(() => {
            dispatch(
                accessUser_ManagementList_RequestActionHandler('', currentPage)
            );
            dispatch(userManagement_roles_list_ActionHandler());
            dispatch(workspace_roles_Permission_ActionHandler());
            dispatch(workspaces_List_ActionHandler('', '', currentPage));
        });
    };

    const handleSendReInvite = async (id) => {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `access-management/users/${id}/resend-invite-code`,
        })
            .then((success) => {
                if (success?.data?.data) {
                    Swal.fire({
                        icon: 'success',
                        title: success?.data?.data,
                        showConfirmButton: false,
                        timer: 3500,
                    });
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: 'Re-invite code sent successfully',
                        showConfirmButton: false,
                        timer: 3500,
                    });
                }
            })
            .catch((err) => {});
    };

    const handleDeleteRole = (id) => {
        if (id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this User!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(SupportingDocumentUserDeleteHandler(id));
                    setTimeout(() => {
                        dispatch(
                            accessUser_ManagementList_RequestActionHandler(
                                searchValue,
                                currentPage
                            )
                        );
                    }, 2000);
                }
            });
        }
    };
    useEffect(() => {
        if (userManagementRolesList) {
            setRollData(userManagementRolesList?.data?.roles);
        }
    }, [userManagementRolesList]);
    useEffect(() => {
        if (workspaceData) {
            setWorkSpaceRoleData(workspaceData);
        }
    }, [workspaceData]);
    useEffect(() => {
        if (workspacesRolesList) {
            setWorkSpace(workspacesRolesList?.data?.roles);
        }
    }, [workspacesRolesList]);
    useEffect(() => {
        dispatch(
            accessUser_ManagementList_RequestActionHandler('', currentPage)
        );
        dispatch(userManagement_roles_list_ActionHandler());
        dispatch(workspace_roles_Permission_ActionHandler());
        dispatch(workspaces_List_ActionHandler('', '', currentPage));
    }, []);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(
            accessUser_ManagementList_RequestActionHandler(searchValue, page)
        );
    };
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    const handlesearch = debounce((e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            setSearchValue(value);
            dispatch(
                accessUser_ManagementList_RequestActionHandler(
                    value,
                    currentPage
                )
            );
        } else {
            dispatch(
                accessUser_ManagementList_RequestActionHandler('', currentPage)
            );
        }
    }, 1000);

    return (
        <>
            <div>
                <div className='usermanagement-container'>
                    <div className='usermanagement-main_1'>
                        <div className='relative search-container'>
                            <input
                                type='text'
                                placeholder='Search user here'
                                className='usermanagement-search-from-logs'
                                defaultValue={searchValue}
                                onChange={(e) => handlesearch(e)}
                            />
                            <img
                                src={SearchIcon}
                                alt=''
                                className='search-icon upicon'
                            />
                        </div>
                        <div className='workspace-management-roles'>
                            <div className='workspace-management-roles-div'>
                                <div className='workspace-management-roles-backgroud workspace-management-roles-super-admin-div'></div>
                                <label className='workspace-management-roles-super-admin'>
                                    Super Admin
                                </label>
                            </div>
                            <div className='workspace-management-roles-div'>
                                <div className='workspace-management-roles-backgroud workspace-management-roles-admin-div'></div>
                                <label className='workspace-management-roles-admin'>
                                    Admin
                                </label>
                            </div>
                            <div className='workspace-management-roles-div'>
                                <div className='workspace-management-roles-backgroud workspace-management-roles-user-div'></div>
                                <label className='workspace-management-roles-user'>
                                    User
                                </label>
                            </div>
                        </div>
                        <div className='usermanagement-main'>
                            <div>
                                <div className='usermanagement-parent9'>
                                    <Button
                                        className='activeusermanagement'
                                        onClick={AddCreditsOverlay}>
                                        <img
                                            className='build-icon'
                                            alt=''
                                            src={vuesaxlinearusercirlceadd}
                                        />
                                        Create User
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={userManagementList?.data?.data}
                        size='middle'
                        pagination={{
                            pageSize: userManagementList?.data?.per_page,
                            total: userManagementList?.data?.total,
                            showSizeChanger: false,
                            onChange: handlePageChange,
                        }}
                        className='mytable'
                        scroll={{ x: 1300 }}
                    />
                </div>
                {isAddCreditsOpen ? (
                    <CreateUser
                        AddCreditsOverlay={AddCreditsOverlay}
                        isAddCreditsOpen={isAddCreditsOpen}
                    />
                ) : null}
            </div>
        </>
    );
};
export default UserManagementTab;
